import Icon from '../components/Icon.vue'

Icon.register({"chess-rook":{"width":384,"height":512,"paths":[{"d":"M81.2 215C81 258.9 77.4 348.1 48 448H336C306.6 348.4 303 259.1 302.8 215L348.2 172.7A12-12 0 0 1 352 163.9V44C352 37.4 346.6 32 340 32H300C293.4 32 288 37.4 288 44V88H240V44C240 37.4 234.6 32 228 32H156C149.4 32 144 37.4 144 44V88H96V44C96 37.4 90.6 32 84 32H44C37.4 32 32 37.4 32 44V163.9C32 167.3 33.4 170.4 35.8 172.7L81.2 215zM160 256C160 238.3 174.3 224 192 224 209.7 224 224 238.3 224 256V320H160V256zM384 476V500C384 506.6 378.6 512 372 512H12C5.4 512 0 506.6 0 500V476C0 469.4 5.4 464 12 464H372C378.6 464 384 469.4 384 476z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/chess-rook.js
// module id = Z3Ee
// module chunks = 0